import { atom } from 'jotai';
import { AppSettings } from '../types';

/**
 * Atom to store application settings
 */
const settingsAtom = atom<AppSettings | null>(null);

/**
 * Read-only atom to get settings
 */
export const getSettingsAtom = atom<AppSettings | null>((get) => get(settingsAtom));

/**
 * Write-only atom to set settings
 */
export const setSettingsAtom = atom(
  null,
  (_get, set, update: AppSettings | null) => {
    set(settingsAtom, update);
  }
);

/**
 * Atom to get current stage
 */
export const stageAtom = atom<string>((get) => {
  const settings = get(settingsAtom);
  return settings?.stage || 'local';
});

/**
 * Atom to get Cognito configuration
 */
export const cognitoConfigAtom = atom((get) => {
  const settings = get(settingsAtom);
  return settings?.cognitoConfig || null;
});

/**
 * Atom to get API configuration
 */
export const apiConfigAtom = atom((get) => {
  const settings = get(settingsAtom);
  return settings?.apiConfig || null;
});

/**
 * Atom to get a specific API endpoint by name
 */
export const getApiEndpointAtom = atom((get) => (apiName: string): string | undefined => {
  const apiConfig = get(apiConfigAtom);
  if (!apiConfig) return undefined;
  
  const endpoint = apiConfig.endpoints.find(ep => ep.name === apiName);
  return endpoint?.endpoint;
});
